import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ArrowAnnotation"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.2825 9.2175L5.565 4.5H10.5V3H3V10.4925L4.5 10.5075V5.5575L9.2175 10.275L10.2825 9.2175ZM14.25 18.75H15.75V13.5H18V12H12V13.5H14.25V18.75ZM13.5 7.5H21C21.8284 7.5 22.5 8.17157 22.5 9V21C22.5 21.8284 21.8284 22.5 21 22.5H9C8.17157 22.5 7.5 21.8284 7.5 21V13.5H9V21H21V9H13.5V7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ArrowAnnotation.vue"]]);
